export const SIGN_IN = 'SIGN_IN';
export const SIGN_IN_UPDATE = 'SIGN_IN_UPDATE';
export const SIGN_UP = 'SIGN_UP';
export const SIGN_UP_UPDATE = 'SIGN_UP_UPDATE';
export const SIGN_OUT = 'SIGN_OUT';
export const REQ_DATA = 'REQ_DATA';
export const DEPT_DATA = 'DEPT_DATA';
export const BLOCK_DATA = 'BLOCK_DATA';
export const ORDERS_DATA = 'ORDERS_DATA';
export const PRODUCTS_DATA = 'PRODUCTS_DATA';
export const RESTAURANTS_DATA = 'RESTAURANTS_DATA';
export const PUBLIC_RESTAURANTS_DATA = 'PUBLIC_RESTAURANTS_DATA';
export const ADD_CART_DATA = 'ADD_CART_DATA';
export const UPDATE_CART_DATA = 'UPDATE_CART_DATA';
export const REMOVE_CART_DATA = 'REMOVE_CART_DATA';
export const SYNC_CART_DATA = 'SYNC_CART_DATA';
export const LOG_ERROR = 'LOG_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_CART_DATA = 'CLEAR_CART_DATA';
export const ORDERS_REPORT_DATA = 'ORDERS_REPORT_DATA';
export const ROOM_BILLS = 'ROOM_BILLS';
export const SELECTED_RESTAURANT_DATA = 'SELECTED_RESTAURANT_DATA';
export const GLOBAL_CONFIG = 'GLOBAL_CONFIG';
